import React, { useCallback, useRef, useState } from 'react';
import { KIDS_COMBO, TRY_2_COMBO } from '../../../../constants';
import { IApplyButton } from '../../../../models/try2Combo';
import styleClasses from '../../try2.module.scss';

const ApplyButton: React.FC<IApplyButton> = ({ isDisabled,selectedOtherDressingData,clickHandle, btnClass, btnSize, usingIn = TRY_2_COMBO,label="Apply"}) => {

  const [loading, setLoading] = useState<boolean>(false);

  const disableButtonClick = useRef(false);


  const onClick = () => {
    if(usingIn?.toLowerCase() === KIDS_COMBO.toLowerCase()) {
      if(!isDisabled && !loading) {
        setLoading(true)
        clickHandle()
      }
    }else{
    if(disableButtonClick.current) return;
    if(!isDisabled) {
      clickHandle();
      disableButtonClick.current = true;
      setTimeout(() => {
      disableButtonClick.current = false;
      },500)
    }
  }

  }
  
  return (
    <button
      type="button"
      className={`${styleClasses.try2_item_order_btn} btn btn-large ms-0 ${btnSize} ${btnClass} ${isDisabled && 'btn-disabled-grey'}`}
      onClick={onClick}
      data-testid="modal-apply-Button"
    >
    {label}
    </button>
  );
};

export default ApplyButton;
